import React from 'react';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { message } from 'antd';
import { addToFavorite, removeFromFavorite } from 'store/actions/favoriteActions';
import { LIST_FAVOURITE_TUTORS, ADD_TO_FAVOURITE, DELETE_FROM_FAVOURITE } from '../../queries/favourite';
import { useMutation } from '@apollo/react-hooks';
import { newClient } from 'helpers';
import { useLocation } from 'react-router-dom';
const client = newClient('profile');

const Heart = ({ tutorData, isFav, onRefetch }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const pathName = location.pathname.split('/');
	const isTutorsList = pathName[pathName.length - 1] === 'tutors' ? true : false;
	const favouriteList = useSelector(({ favorite }) => favorite?.items);
	const isFavourite = favouriteList.find(item => item.pvid === tutorData.pvid) ? true : false;
	const token = localStorage.getItem('token');
	const isLoggedIn = token ? true : false;
	const fav = isLoggedIn ? isFav : isFavourite;

	const [addToFavouriteTutors] = useMutation(ADD_TO_FAVOURITE, {
		client,
		onCompleted: () => {
			message.success(`added to favourite`);
			onRefetch && onRefetch();
		}
	});

	const [deleteFromFavouriteTutors] = useMutation(DELETE_FROM_FAVOURITE, {
		client,
		onCompleted: () => {
			message.error(`remove from favourite`);
			onRefetch && onRefetch();
		}
	});
	const variables = {
		tutorPvid: tutorData?.pvid
	};

	const handleAddToFavourite = e => {
		e.stopPropagation();
		!isFav
			? isLoggedIn
				? addToFavouriteTutors({ variables })
				: dispatch(addToFavorite(tutorData, () => message.success(`added to favourite`)))
			: isLoggedIn
			? deleteFromFavouriteTutors({ variables })
			: dispatch(removeFromFavorite(tutorData, () => message.error(`remove from favourite`)));
	};
	return fav ? (
		<FilledHeart onClick={e => handleAddToFavourite(e, isFav)} disable={isTutorsList && fav} />
	) : (
		<OutlinedHeart type="heart" fav={fav} disable={isTutorsList && fav} theme="filled" onClick={e => handleAddToFavourite(e, isFav)} />
	);
};

export default Heart;

const OutlinedHeart = styled(HeartOutlined)`
	position: absolute;
	padding: 6px;
	fontsize: 15px;
	top: 0;
	cursor: pointer;
	margin: 10px;
	color: red;

	${props =>
		props.disable &&
		`pointer-events: none;
	   cursor: unset;
	`}
`;

const FilledHeart = styled(HeartFilled)`
	position: absolute;
	padding: 6px;
	fontsize: 15px;
	top: 0;
	cursor: pointer;
	margin: 10px;
	color: red;

	${props =>
		props.disable &&
		`pointer-events: none;
	   cursor: unset;
	`}
`;
